import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { connect } from "react-redux";
import {
  Button,
  Card,
  InputGroup,
  Form as BootstrapForm,
  Container,
} from "react-bootstrap";
import * as Yup from "yup";
import styles from "./AddTerminalSubjectForm.module.css";
import { useNavigate } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import { toast } from "react-toastify";
import {
  createTerminalSubject,
  updateTerminalSubject,
} from "../../actions/TerminalSubject.action";
import { MultiSelect } from "@mantine/core";
import { termArray } from "../../constants/termArray";

const AddTerminalSubjectForm = ({
  createTerminalSubject,
  data,
  edit,
  updateTerminalSubject,
  getGradeList,
  grades,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
  }, []);

  const onSubmitHandeler = async (values) => {
    if (values.gradeId === "none") {
      toast.error("Select a Grade!");
      return false;
    }
    if (values.terms.length === 0) {
      toast.error("Select at least one term!");
      return false;
    }

    // Calculate mark as oral + writing
    const calculatedValues = {
      ...values,
      mark: values.oralMark + values.writingMark,
    };

    setIsLoading(true);
    let check = edit
      ? await updateTerminalSubject(calculatedValues, data.id)
      : await createTerminalSubject(calculatedValues);
    if (check === true) {
      setTimeout(() => {
        setIsLoading(false);
        navigate("/admin/terminal-subject");
      }, 1000);
    } else {
      setIsLoading(false);
    }
  };

  let initVals = {
    name: edit === true && data ? data.name : "",
    oralMark: edit === true && data ? data.oralMark : 50,
    writingMark: edit === true && data ? data.writingMark : 50,
    serial: edit === true && data ? data.serial : 0,
    gradeId: edit === true && data ? data.gradeId : "none",
    terms:
      edit === true && data
        ? data.terms.split(",").map((t) => parseInt(t))
        : [],
  };

  const SignupSchema = Yup.object().shape({
    name: Yup.string().required("Terminal Subject Name is required!"),
    gradeId: Yup.string().required("Class is required!"),
    oralMark: Yup.number()
      .min(0, "Oral Mark must be greater than or equal to 0")
      .required("Oral Mark is required!"),
    writingMark: Yup.number()
      .min(0, "Writing Mark must be greater than or equal to 0")
      .required("Writing Mark is required!"),
    serial: Yup.number()
      .min(0, "Serial must be greater than 0")
      .required("Serial is required!"),
    terms: Yup.array()
      .min(1, "At least one term is required!")
      .required("Terms are required!"),
  });

  return (
    <Container>
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <h1 className="fs-4 fw-normal py-3">
            Fill the form to {edit ? "edit" : "add"} a new terminal subject
          </h1>
          <Formik
            initialValues={initVals}
            validationSchema={SignupSchema}
            enableReinitialize
            onSubmit={(values) => onSubmitHandeler(values)}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="name" className="d-block">
                      Name
                    </label>
                    {errors.name && touched.name ? (
                      <small className="text-danger pt-2">{errors.name}</small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Control}
                    placeholder="Type name of the terminal subject..."
                    name="name"
                    isValid={!errors.name && touched.name}
                    type="text"
                    className={`${styles.input} w-100`}
                    isInvalid={errors.name && touched.name}
                  />
                </InputGroup>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="gradeId" className="d-block">
                      Class
                    </label>
                    {errors.gradeId && touched.gradeId ? (
                      <small className="text-danger pt-2">
                        {errors.gradeId}
                      </small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Select}
                    name="gradeId"
                    isValid={!errors.gradeId && touched.gradeId}
                    isInvalid={errors.gradeId && touched.gradeId}
                    className={`${styles.input} w-100`}
                  >
                    <option value="none">Select Class</option>
                    {grades &&
                      grades.map((grade) => (
                        <option key={grade.id} value={grade.id}>
                          {grade.name}
                        </option>
                      ))}
                  </Field>
                </InputGroup>

                <div className="row">
                  <div className="col-md-6">
                    <InputGroup className="mb-3 d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <label htmlFor="oralMark" className="d-block">
                          Oral Mark
                        </label>
                        {errors.oralMark && touched.oralMark ? (
                          <small className="text-danger pt-2">
                            {errors.oralMark}
                          </small>
                        ) : null}
                      </div>
                      <Field
                        as={BootstrapForm.Control}
                        placeholder="Type oral mark..."
                        name="oralMark"
                        isValid={!errors.oralMark && touched.oralMark}
                        type="number"
                        className={`${styles.input} w-100`}
                        isInvalid={errors.oralMark && touched.oralMark}
                      />
                    </InputGroup>
                  </div>
                  <div className="col-md-6">
                    <InputGroup className="mb-3 d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <label htmlFor="writingMark" className="d-block">
                          Writing Mark
                        </label>
                        {errors.writingMark && touched.writingMark ? (
                          <small className="text-danger pt-2">
                            {errors.writingMark}
                          </small>
                        ) : null}
                      </div>
                      <Field
                        as={BootstrapForm.Control}
                        placeholder="Type writing mark..."
                        name="writingMark"
                        isValid={!errors.writingMark && touched.writingMark}
                        type="number"
                        className={`${styles.input} w-100`}
                        isInvalid={errors.writingMark && touched.writingMark}
                      />
                    </InputGroup>
                  </div>
                </div>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="mark" className="d-block">
                      Mark (Total)
                    </label>
                    <small className="text-muted">
                      <i className="fas fa-calculator me-1"></i>
                      (Oral + Writing)
                    </small>
                  </div>
                  <BootstrapForm.Control
                    type="number"
                    className={`${styles.totalMarkField} w-100`}
                    value={values.oralMark + values.writingMark}
                    readOnly
                  />
                </InputGroup>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="terms" className="d-block">
                      Terms
                    </label>
                    {errors.terms && touched.terms ? (
                      <small className="text-danger pt-2">{errors.terms}</small>
                    ) : null}
                  </div>
                  <MultiSelect
                    data={termArray.map((term) => ({
                      value: term.id,
                      label: term.label,
                    }))}
                    value={values.terms}
                    onChange={(value) => setFieldValue("terms", value)}
                    placeholder="Select terms..."
                    searchable
                    clearable
                    className="w-100"
                  />
                </InputGroup>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="serial" className="d-block">
                      Serial
                    </label>
                    {errors.serial && touched.serial ? (
                      <small className="text-danger pt-2">
                        {errors.serial}
                      </small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Control}
                    placeholder="Type serial of the terminal subject..."
                    name="serial"
                    isValid={!errors.serial && touched.serial}
                    type="number"
                    className={`${styles.input} w-100`}
                    isInvalid={errors.serial && touched.serial}
                  />
                </InputGroup>

                <div className="pt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className="btn_primary"
                    disabled={isLoading}
                  >
                    {isLoading
                      ? "Loading..."
                      : edit
                      ? "Edit Terminal Subject"
                      : "Add Terminal Subject"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  createTerminalSubject,
  updateTerminalSubject,
  getGradeList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTerminalSubjectForm);
